import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';

import { Modal } from "./Index";

import { closeModal, getModalData, isModalActive } from "../../store/modal.slice";

const MODAL_NAME = "CONFIRMATION_MODAL";

export const ConfirmationModal = () => {
    const dispatch = useDispatch();

    const isModalOpen = useSelector(isModalActive(MODAL_NAME)); // eslint-disable-line
    const modalData = useSelector(getModalData(MODAL_NAME));

    const { topupLvl, title, description, onConfirm } = modalData ?? {};

    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    const onCloseModal = () => {
        dispatch(closeModal(MODAL_NAME));
    };

    const handleConfirm = async () => {
        if (isProcessing) return;

        setIsProcessing(true);
        await onConfirm();
        setIsProcessing(false);

        onCloseModal();
    };

    return (
        <Modal
            name={MODAL_NAME}
            title="Confirmation"
            baseClass="confirmation"
            topupLvl={topupLvl ?? 0}
            onClose={onCloseModal}
            shouldCloseOnEsc={false}
            shouldCloseOnOverlayClick={false}
        >
            <p className="color--primary text-xl text-bold mb-md">{title}</p>
            <p className="text-lg color--txt-secondary mb-2xl">{description}</p>
            <div className="modal__confirmation_actions">
                <button
                    className="btn btn--sm btn--radius-sm btn--primary"
                    onClick={handleConfirm}
                    disabled={isProcessing}
                >
                    <span>{isProcessing ? 'Processing...' : 'Confirm'}</span>
                    {isProcessing && <span className="btn-loader" />}
                </button>
                <button
                    className="btn btn--sm btn--radius-sm btn--secondary"
                    onClick={onCloseModal}
                    disabled={isProcessing}
                >
                    <span>Cancel</span>
                </button>
            </div>
        </Modal>
    );
};